import {
  Action,
  combineReducers,
  configureStore,
  ThunkAction,
} from "@reduxjs/toolkit";
import authReducer from "../views/auth/sagas/authSlice";
import meReducer from "../views/auth/sagas/meSlice";
import createSagaMiddleware from "redux-saga";
import rootSaga from "./rootSaga";
import brandReducer from "views/superuser/brand/saga/brandSlice";
import userReducer from "views/superuser/user/sagas/userSlice";
import storeReducer from "views/superuser/stores/saga/storeSlice";
import platformReducer from "views/superuser/platform/saga/platformSlice";
import userModulesReducer from "views/superuser/userModule/sagas/userModuleSlice";
import activitylogReducer from "views/superuser/activitylog/saga/activitylogSlice";
import paymentReducer from "views/superuser/payment/sagas/paymentSlice";
import subscriptionReducer from "views/superuser/Subscriptions/sagas/subscriptionSlice";
import brandLocationReducer from "views/superuser/BrandLocatioManage/sagas/brandLocationSlice";
import documentReducer from "views/superuser/documentManage/sagas/documentSlice";
import assignPlatformReducer from "views/superuser/platformAssign/saga/platformAssignSlice";
import notificationReducer from "views/superuser/notification/sagas/notificationSlice";
import adminManageReducer from "views/superuser/adminmanage/saga/adminManageSlice";
import generalSettingReducer from "views/superuser/generalSetting/saga/generalSettingSlice";
import customersReducer from "views/superuser/customers/saga/customersSlice";
import packageReducer from "views/superuser/packagemanage/sagas/packageSlice";
import accessRoleReducer from "views/superuser/accessRole/saga/accessRoleSlice";
import couponManageReducer from "views/superuser/couponmanage/sagas/couponManageSlice";
import couponUsageReducer from "views/superuser/couponUsage/saga/couponUsageSlice";
import roleModuleReducer from "views/superuser/rolemodule/sagas/roleModuleSlice";
import adminUserMgmtAdminUsersReducer from "views/superuser/adminUserManagement/sagas/adminUsersSlice";
import adminUserMgmtAccessRoleReducer from "views/superuser/adminUserManagement/sagas/accessRoleSlice";
import adminUserMgmtPermissionReducer from "views/superuser/adminUserManagement/sagas/permissionSlice";
import dashBoardReducer from "views/superuser/dashboard/saga/dashBoardSlice";
import statementReducer from "views/superuser/statement/sagas/statementSlice";
import invoiceReducer from "views/superuser/invoice/sagas/inVoiceSlice";
import enumReducer from "views/superuser/enumConfiguration/sagas/enumSlice";
import groupReducer from "views/superuser/group/saga/groupSlice";
import inquiryReducer from "views/superuser/inquiry/saga/inquirySlice";
import kotReducer from "views/superuser/brand/saga/kotSlice";
import deviceReducer from "views/superuser/brand/saga/deviceSlice";
import quotationReducer from "views/superuser/quotation/sagas/quotationSlice";

const rootReducer = combineReducers({
  auth: authReducer,
  me: meReducer,
  brands: brandReducer,
  users: userReducer,
  stores: storeReducer,
  quotationModule: quotationReducer,
   enumModule: enumReducer, 
  platforms: platformReducer,
  usersModule: userModulesReducer,
  paymentModule: paymentReducer,
  inVoiceModule: invoiceReducer,
  groupModule: groupReducer,
  activitylog: activitylogReducer,
  subscription: subscriptionReducer,
  brandLocation: brandLocationReducer,
  document: documentReducer,
  assignPlatform: assignPlatformReducer,
  notification: notificationReducer,
  adminManage: adminManageReducer,
  generalSetting: generalSettingReducer,
  customers: customersReducer,
  package: packageReducer,
  accessRole: accessRoleReducer,
  kot: kotReducer,
  device: deviceReducer,
  couponManage: couponManageReducer,
  couponUsage: couponUsageReducer,
  roleModule: roleModuleReducer,
  dashBoard: dashBoardReducer,
  statement: statementReducer,
  inquiry: inquiryReducer,
  adminUserMgmtAdminUsers: adminUserMgmtAdminUsersReducer,
  adminUserMgmtAccessRole: adminUserMgmtAccessRoleReducer,
  adminUserMgmtPermission: adminUserMgmtPermissionReducer,
});

const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(sagaMiddleware),
});

sagaMiddleware.run(rootSaga);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
